module.exports = __webpack_public_path__ + "media/images/sp/articles/report_temp_02-81d169ab7b694cff17794f751dcc0022.webp";